"use strict";
exports.__esModule = true;
exports.synthesizeNumber = void 0;
function synthesizeNumber(schema, options) {
    var _a, _b, _c, _d;
    var random = options.random;
    var minimum = (_b = (_a = schema.minimum) !== null && _a !== void 0 ? _a : options.minimum) !== null && _b !== void 0 ? _b : 0;
    var maximum = (_d = (_c = schema.maximum) !== null && _c !== void 0 ? _c : options.maximum) !== null && _d !== void 0 ? _d : minimum + 10;
    var span = Math.max(maximum - minimum, 0);
    if (schema.type === 'integer') {
        return minimum + Math.floor(span * random());
    }
    if (schema.type === 'number') {
        return minimum + Math.floor(span * 10 * random()) / 1;
    }
    return 0;
}
exports.synthesizeNumber = synthesizeNumber;
